import { GET, POST, PUT, DELETE } from "./api";
import axios from "axios";

export const ReadNotifications = async () => {
  return await GET(`/v1/notifications`, true);
};

export const SaveDeviceToken = async (params) => {
  return await POST(`/v1/notifications/token`, params, true);
};

export const UpdateNotification = async (params, id) => {
  return await PUT(`/v1/notifications/${id}`, params, true);
};

export const RemoveNotification = async (id) => {
  return await DELETE(`/v1/notifications/${id}`, true);
};

export const RemoveAllNotifications = async () => {
  return await DELETE(`/v1/notifications-all`, true);
};

// método para fazer as notificações push
export const sendNotificationMessage = async (messageRequest) => {
  try {
    const API_NOTIFICATION_ENDPOINT =
      "https://www.asseweb.com.br/ApiNotificacao/api/message/sendMessageToken";
    //const API_NOTIFICATION_ENDPOINT = "https://localhost:7094/api/message/sendMessageToken";

    // Realiza a requisição POST com Axios
    const response = await axios.post(
      API_NOTIFICATION_ENDPOINT,
      messageRequest,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    // Retorna os dados da API em caso de sucesso
    return response.data;
  } catch (err) {
    // Lida com erros de rede ou da API
    if (err.response) {
      // Caso a resposta da API tenha sido recebida com erro
      console.error(
        `Erro na API: ${err.response.status} - ${err.response.data.message}`
      );
      return {
        error: true,
        message: err.response.data.message || "Erro desconhecido na API",
      };
    } else if (err.request) {
      // Caso nenhuma resposta tenha sido recebida
      console.error("Erro de conexão: nenhuma resposta recebida da API");
      return {
        error: true,
        message: "Erro de conexão: nenhuma resposta recebida da API",
      };
    } else {
      // Outros erros
      console.error("Erro ao enviar mensagem:", err.message);
      return {
        error: true,
        message: err.message || "Erro desconhecido ao enviar mensagem",
      };
    }
  }
};
